import React, { useEffect, useState } from "react";

export default function RequireAdmin({ children }) {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    fetch("/api/me.php", { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        // 1. proviamo a leggere TUTTE le forme possibili
        const rolesFromArray = Array.isArray(data.roles)
          ? data.roles
          : Array.isArray(data.user?.roles)
          ? data.user.roles
          : [];

        // 2. nel tuo caso arriva COME STRINGA: "ruolo": "superadmin"
        const singleRole = data.ruolo || data.user?.ruolo || null;

        // 3. permessi (nel tuo caso: ["ALL"])
        const perms =
          data.permessi ||
          data.permissions ||
          data.user?.permessi ||
          [];

        // costruiamo una lista finale di ruoli
        const allRoles = [...rolesFromArray];
        if (singleRole && !allRoles.includes(singleRole)) {
          allRoles.push(singleRole);
        }

        const allowedRoles = [
          "admin",
          "superadmin",
          "superuser",
          "root",
        ];

        const hasAllowedRole = allRoles.some((r) =>
          allowedRoles.includes(r)
        );

        const hasAdminPerm =
          Array.isArray(perms) &&
          (perms.includes("ALL") || perms.includes("ADMIN_PANEL"));

        // decidiamo
        if (hasAllowedRole || hasAdminPerm) {
          setStatus("ok");
        } else {
          setStatus("forbidden");
        }
      })
      .catch(() => setStatus("error"));
  }, []);

  if (status === "loading") return <div>Caricamento…</div>;
  if (status === "forbidden") return <div>Non hai i permessi.</div>;
  if (status === "error") return <div>Errore di rete.</div>;
  return children;
}
